// extracted by mini-css-extract-plugin
module.exports = {"plates":"Plates_plates__L6ixS","plate":"Plates_plate__kx9Bh"};